import {useCallback, useEffect, useRef, useState} from 'react';

export const useScrollWrapDimensions = () => {
    const wrapRef = useRef<HTMLElement | null>(null);
    const [dimensions, setDimensions] = useState({maxWidth: 0, maxHeight: 0});

    const setWrapRef = useCallback((el: HTMLElement | null) => {
        if (el) {
            wrapRef.current = el;
        }
    }, []);

    useEffect(() => {
        const observer = new ResizeObserver(function (entries) {
            // since we are observing only a single element, so we access the first element in entries array
            const rect = entries[0].contentRect;

            // current width & height
            const width = rect.width;
            const height = rect.height;

            setDimensions({maxWidth: width, maxHeight: height});
        });

        observer.observe(wrapRef.current);

        return () => {
            observer.unobserve(wrapRef.current);
        };
    }, []);

    return {...dimensions, setWrapRef};
};
